export const metricsPermission = {
    metricsMenuItem: "menu-item.view-metric",
    metricDataView: "metric-data.view",
    metricErrorRatePerSite: "metric.error-rate-per-site",
    metricErrorRatePerBrand: "metric.error-rate-per-brand",
    metricErrorRatePerBrandAndBranch: "metric.error-rate-per-brand-and-branch",
    metricCountScrapedIssuesPerBrand: "metric.count-scraped-issues-per-brand",
    metricCountScrapedIssuesPerBranch: "metric.count-scraped-issues-per-branch",
    metricTaskStart: "metric-task.start",
    metricTasksView: "metric-tasks.view",
    metricTaskCreate: "metric-task.create",
    metricTaskDelete: "metric-task.delete",
    metricTaskUpdate: "metric-task.update",
    metricGroupCreate: "metric-group.create",
    metricGroupsView: "metric-groups.view",
    metricGroupUpdate: "metric-group.update",
    metricGroupDelete: "metric-group.delete",
    metricDataCollectionStatus: "metric-data-collection-status.get",
    metricKeywordScanStats: "keyword-scan-stats.get"
};
